import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

export function GetDateObjectFromString(date: string): NgbDateStruct {
  if (!date) {
    return null;
    // the object with null values is not accepted by the ngbDatepicker validator
    // return { year: null, month: null, day: null };
  }
  const d = new Date(date);
  const year = d.getUTCFullYear();
  const month = d.getUTCMonth() + 1;
  const day = d.getUTCDate();
  return year ? { year, month, day } : null;
}
